// store index.js
import {getToken, setToken, setUserInfo, getUserInfo} from '@/utils/auth'
import Vuex from 'vuex'
import Vue from 'vue'
import $ from 'jquery'
Vue.use(Vuex)

const state = {
  user: getUserInfo(),
  token: getToken(),
  // loginPopStatus: false,
  loginStatus: !!getToken(),
  shoppingCartNum: 0,
  orderSkuIds: false,
  applyTrial: false,
  chargeStatus: false,
  init_order_count: 0,
  success_order_count: 0,
  send_order_count: 0,
  operation_type: false,
  organInfo: null,
}

const mutations = {
  SET_TOKEN: (state, data) => {
    state.token = data.token
    setToken(data.token)
  },
  GET_USER: (state, data) => {
    state.user = data
    setUserInfo(data)
  },
  LOGIN: (state, data) => {
    state.loginStatus = data
  },
  LOGOUT: (state) => {
    state.token = false
    state.user = false
    state.loginStatus = false
    setToken(false)
    setUserInfo(false)
  },
  SET_ISMARSCLUB: (state, data) => {
    state.isMarsclubStatus = data
  },
  GET_SHOPPINGCART_NUM: (state,data) => {
    state.shoppingCartNum = data;
  },
  GET_ORDER_SKUIDS: (state,data) => {
    state.orderSkuIds = data;
    //在页面刷新时将vuex里的信息保存到localStorage里
    localStorage.setItem("userMsg",JSON.stringify(state));
  },
  SET_ISTRIAL: (state,data) => {
    state.applyTrial = data;
  },
  SET_ISCHARGE: (state,data) => {
    state.chargeStatus = data;
  },
  GET_ORDER_COUNT: (state,data) => {
    state.init_order_count = data.init_order_count;
    state.success_order_count = data.success_order_count;
    state.send_order_count = data.send_order_count;
  },
  SET_SCRATCH_SELECTION: (state,data) => {
    state.operation_type = data;
  },
  SAVE_ICON_AND_NAME:  (state, data) => {
    state.organInfo = data;
  },
}

const actions = {}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js